import React, { useEffect } from "react";
import Coverbanner from "../Mobile/coverImage/Coverbanner";
import Mobilemain from "../Mobile/mobile.Main/Mobilemain";
import Footer from "../Mobile/Mobilefooter/Footer";
import Header from "../Mobile/MobileHeader/Header";
import { connect } from "react-redux";
import Loading from "../Loading/Loading";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import { encode } from "base-64";
const Cookie = new Cookies();
function MobileMain({ rootData, mainView }) {
  let history = useHistory();
  var token = Cookie.get("wmtoken");
  useEffect(() => {
    if (!token) {
      history.push(`/login?service=${history.location.pathname.substring(1)}`)
    }
  }, [])
  return (
    <div className="block lg:hidden">
      {/* {token ? ( */}
        {rootData.isProfileLoaded ? (
          <Loading className={"block md:hidden"} />
        ) : (
          <>
            <Header />
            <Coverbanner />
            <Mobilemain mainView={mainView} />
            <Footer />
          </>
        )}
      
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};
export default connect(mapStateToProps, null)(MobileMain);
